import styled from 'styled-components';

const ToolbarTitle = styled.div`
  color: var(--accent-color-blue);
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`;

export default ToolbarTitle;
